import React from "react";
import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";

import TripSearchForm from "./TripSearchForm";
import LoadingPage from "../../components/LoadingFlightsPage";
import { fetchTripById } from "../../data/trips/actions";

const TripSearchPage = ({
  errorFetchTripById,
  tripIsFetching,
  fetchTripById,
  customerEmail,
  handleSubmit: handleSubmitReduxForm
}) => {
  // console.log('somto', fetchTripById)
  return (
    <div>
      <LoadingPage isHidden={!tripIsFetching} />
      <TripSearchForm
        onSearch={handleSubmitReduxForm(fetchTripById)}
        errorFetchTripById={errorFetchTripById}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    errorFetchTripById: state.trips.errorFetchTripById,
    tripIsFetching: state.trips.fetchingTrips,
    customerEmail: formValueSelector("tripSearch")(state, "customerEmail"),
    tripId: formValueSelector("tripSearch")(state, "tripId")
  };
}
// function mapDispatchToProps(dispatch) {
//   return {
//     fetchTripById: function() {
//       dispatch(fetchTripById());
//     }
//   };
// }

// export default connect(mapStateToProps, mapDispatchToProps)(TripSearchPageHOC);

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { customerEmail, tripId } = stateProps;
  const { dispatch } = dispatchProps;
  const { history } = ownProps;

  const formValues = { customerEmail, tripId };

  // const departureDate = "2018-06-15" // TODO get from props

  return {
    ...ownProps, //provides parent props that have nothing to do with redux-form (in this case, only react-router's history obj).
    ...stateProps, // provides result from mapStateToProps e.g. 'fetchingTrips' to component
    fetchTripById: () => {
      dispatch(fetchTripById({ history, formValues }));
    }
  };
}

function validate(values, props) {
  var errors = {};
  // var errorMessage;

  const requiredFields = ["customerEmail", "tripId"];

  var field = "customerEmail";
  if (!isValidEmail(values[field])) {
    errors[field] = "Enter valid email";
  }

  field = "tripId";
  if (!Number.isInteger(Number(values[field]))) {
    errors[field] = "Enter numeric value";
  }

  requiredFields.forEach(field => {
    if (isEmpty(values[field])) {
      errors[field] = "Required";
    }
  });

  // UTIL
  function isEmpty(str) {
    if (!str) return true;
    if (typeof str === "string") return !!str.trim() === false;
    return false;
  }

  // http://stackoverflow.com/a/46181/2213882
  function isValidEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  return errors;
}

const TripSearchPageHOC = reduxForm({
  form: "tripSearch",
  validate
})(TripSearchPage);

export default connect(mapStateToProps, null, mergeProps)(TripSearchPageHOC);



// WEBPACK FOOTER //
// ./src/scenes/TripSearchPage/index.js